import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import { setPreferredVideoQuality } from '../../../react/features/video-quality/actions';
/**
 * Listens when the conference is available.
 */
StateListenerRegistry.register(state => state['features/base/conference'].conference, 
/* listener */ (conference, { dispatch, getState }) => {
    if (!conference) {
        return;
    }
    const state = getState();
    const { videoQuality = {} } = state['features/base/config'];
    const { persistedPrefferedVideoQuality } = state['features/video-quality-persistent-storage'];
    if (videoQuality.persist && typeof persistedPrefferedVideoQuality !== 'undefined') {
        dispatch(setPreferredVideoQuality(persistedPrefferedVideoQuality));
    }
});
